<div class="db-front-end__general" *ngIf="!notConnected || website?.domain_hash">
  <div>
    <db-booster-notices [websiteId]="websiteId"></db-booster-notices>
    <div class="db-flex-box db-front-end__main"
         [ngClass]="{'padding-bottom-frontend': currentSubscription?.bundleClient || currentSubscription?.oneProductClient}">
      <div>
        <db-booster-general [companyName]="companyName" [boosterModeLoading]="boosterModeLoading" [enabledCdnCount]="enabledCdnCount"></db-booster-general>
      </div>
      <div class="db-floating-box-wrap"
           *ngIf="boosterPluginIsActive && currentSubscription?.trialBoosterClient">
        <db-subscription-block [userSubscription]="currentSubscription" [websiteId]="websiteId"></db-subscription-block>
        <!--<db-optimize-with-booster-pro [imageStats]="stats" [pageCount]="pageCount"
                                      [websiteId]="websiteId"></db-optimize-with-booster-pro>-->
      </div>
    </div>
  </div>
</div>

<div class="db-trouble-instructions" *ngIf="notConnected && !website?.domain_hash">
  <div>
    <db-booster-trouble-instructions [insideWebsite]="true" [website]="website" [currentSubscription]="currentSubscription"></db-booster-trouble-instructions>
  </div>
</div>
